import ApiService from "@/services/api.service";
import SettingsService from "@/services/settings.service.js";
import { sortAlphanum } from "../alphanumericSort";

const state = {};

const getters = {};

const actions = {
  getFeeGuides({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "guides/" + options.coverage;
    return ApiService.get(url);
  },
  getBenefits({ commit }) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "benefits?$expand=Translations($select=Name,LanguageCode)&$select=Id,Name";
    return ApiService.get(url);
  },
  importFeeGuide({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "guides/import";
    let formData = new FormData();
    formData.append("File", options.file);
    formData.append("Model", JSON.stringify(options.payload));
    return ApiService.postFile(url, formData);
  },
  importBenefits({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "benefits/import";
    let formData = new FormData();
    formData.append("File", options.file);
    return ApiService.postFile(url, formData);
  },
  addBenefits({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "benefits";
    return ApiService.post(url, options.payload);
  },
  updateBenefit({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}benefits/${options.id}`;
    return ApiService.put(url, options.payload);
  },
  deleteBenefits({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}benefits/delete`;
    return ApiService.post(url, options.payload);
  },
  searchClaims({ state }, options) {
    console.log("search options", options);
    const settings = SettingsService.settings;
    let filters = [];
    if (options.memberGroups.length > 0) {
      const memberGroupsFilter = `Claims/any(__c_t: __c_t/CurrentClaimData/PlanBenefit/MemberGroupId in (${options.memberGroups
        .map((o) => o.IdentityId)
        .join(", ")}))`;
      filters.push(`(${memberGroupsFilter})`);
    }
    if (options.submissionId) {
      let parts = options.submissionId.split("-");
      let sequence = parts[parts.length - 1];
      filters.push(`contains(Sequence, '${sequence.replaceAll("'", "''")}')`);
    }

    if (options.memberCertificate) {
      filters.push(`MemberCertificate eq '${options.memberCertificate.replaceAll("'", "''")}'`);
    }

    // Timestamp ge 2022-04-16T00:00:00.0000000Z and Timestamp le 2022-10-16T23:59:59.999999Z
    if (options.submissionDates && options.submissionDates.length === 2) {
      filters.push(
        `Timestamp ge ${
          options.submissionDates[0] + "T00:00:00.0000000Z"
        } and Timestamp le ${options.submissionDates[1] + "T23:59:59.999999Z"}`
      );
    }

    if (options.submissionDates && options.submissionDates.length === 1) {
      let date = new Date(options.submissionDates[0]);
      date.setDate(date.getDate() + 1);
      filters.push(
        `Timestamp ge ${
          options.submissionDates[0] + "T00:00:00.0000000Z"
        } and Timestamp lt ${date.toISOString()}`
      );
    }

    if (options.expenseDates.length === 2) {
      filters.push(
        `Claims/any(__c_t: __c_t/CurrentClaimData/DateOfService ge ${
          options.expenseDates[0] + "T00:00:00.0000000Z"
        } and __c_t/CurrentClaimData/DateOfService le ${
          options.expenseDates[1] + "T23:59:59.999999Z"
        })`
      );
    }

    if (options.expenseDates.length === 1) {
      let date = new Date(options.expenseDates[0]);
      date.setDate(date.getDate() + 1);
      filters.push(
        `Claims/any(__c_t: __c_t/CurrentClaimData/DateOfService ge ${
          options.expenseDates[0] + "T00:00:00.0000000Z"
        } and __c_t/CurrentClaimData/DateOfService lt ${date.toISOString()})`
      );
    }

    if (options.paymentDates.length === 2) {
      filters.push(
        `Payments/any(__c_t: __c_t/PaymentBatch/IssuedAt ge ${
          options.paymentDates[0] + "T00:00:00.0000000Z"
        } and __c_t/PaymentBatch/IssuedAt le ${
          options.paymentDates[1] + "T23:59:59.999999Z"
        })`
      );
    }

    if (options.paymentDates.length === 1) {
      let date = new Date(options.paymentDates[0]);
      date.setDate(date.getDate() + 1);
      filters.push(
        `Payments/any(__c_t: __c_t/PaymentBatch/IssuedAt ge ${
          options.paymentDates[0] + "T00:00:00.0000000Z"
        } and __c_t/PaymentBatch/IssuedAt lt ${date.toISOString()})`
      );
    }

    // if (options.patientIds && options.patientIds.length) {
    //   console.log("patientIds", options.patientIds);
    //   let idsString = "";
    //   options.patientIds.forEach((id, i) => {
    //     if (id) {
    //       idsString += id + ", ";
    //     } else {
    //       idsString += "null, ";
    //     }
    //   });
    //   idsString = idsString.slice(0, -2);
    //   filters.push(`Claims/any(__c_t: __c_t/DependantId in (${idsString}))`);
    // }

    if (options.patient) {
      // console.log("patient", options.patient);
      // filters.push(`Claims/any(__c_t: __c_t/Dependant/FirstName in (${idsString}))`);
      const parts = options.patient.split(" ");
      for (let i = 0; i < parts.length; i++) {
        filters.push(
          `Claims/any(__c1_t: contains(tolower(__c1_t/FirstName), '${parts[i]
            .toLowerCase()
            .replaceAll(
              "'",
              "''"
            )}') or Claims/any(__c2_t: contains(tolower(__c2_t/LastName), '${parts[
            i
          ]
            .toLowerCase()
            .replaceAll("'", "''")}')))`
        );
      }
    }

    if (options.status && options.status.length > 0) {
      // console.log("status", options.status);
      // filters.push(`Claims/any(__c_t: __c_t/Dependant/FirstName in (${idsString}))`);
      const statusFilter = [];
      for (const s of options.status) {
        statusFilter.push(
          `Claims/any(__c_t: contains(tolower(__c_t/State), '${s
            .toLowerCase()
            .replaceAll("'", "''")}'))`
        );
      }
      filters.push(`(${statusFilter.join(" or ")})`);
    }

    if (options.coverages.length > 0) {
      filters.push(
        `Claims/any(__c_t: __c_t/CurrentClaimData/PlanBenefit/BenefitId in (${options.coverages.join(
          ", "
        )}))`
      );
    }

    if (options.providers.length > 0) {
      filters.push(`ProviderId in (${options.providers.join(", ")})`);
    }

    // if (options.status) {
    //   filters.push(`Status eq ${options.status}`);
    // }

    if (!options.selectAmountRange && options.claimedAmount) {
      // filters.push(`ClaimsTotal eq ${options.claimedAmount}`);
      filters.push(
        `(TotalClaimed eq ${options.claimedAmount} or Claims/any(__c_t: __c_t/TotalClaimed eq ${options.claimedAmount}))`
      );
    }

    if (options.selectAmountRange && options.claimedAmountRange) {
      filters.push(
        // `ClaimsTotal ge ${options.claimedAmountRange[0]} and ClaimsTotal le ${
        //   options.claimedAmountRange[1]
        // }`
        `((TotalClaimed ge ${options.claimedAmountRange[0].toFixed(2)} and TotalClaimed le ${options.claimedAmountRange[1].toFixed(2)}) or (Claims/any(__c_t: __c_t/TotalClaimed ge ${options.claimedAmountRange[0].toFixed(2)} and __c_t/TotalClaimed le ${options.claimedAmountRange[1].toFixed(2)})))`
      );
    }

    if (!options.selectTotalPaidRange && options.totalPaid) {
      // filters.push(`ClaimsTotal eq ${options.claimedAmount}`);
      filters.push(
        `(TotalPaid eq ${options.totalPaid} or Claims/any(__c_t: __c_t/TotalPaid eq ${options.totalPaid}))`
      );
    }

    if (options.selectTotalPaidRange && options.totalPaidRange) {
      filters.push(
        // `ClaimsTotal ge ${options.claimedAmountRange[0]} and ClaimsTotal le ${
        //   options.claimedAmountRange[1]
        // }`
        `((TotalPaid ge ${options.totalPaidRange[0].toFixed(2)} and TotalPaid le ${options.totalPaidRange[1].toFixed(2)}) or (Claims/any(__c_t: __c_t/TotalPaid ge ${options.totalPaidRange[0].toFixed(2)} and __c_t/TotalPaid le ${options.totalPaidRange[1].toFixed(2)})))`
      );
    }

    if (options.userType) {
      filters.push(
        `UserType eq BrokersClaims.Models.Enums.SubmissionSource'${options.userType}'`
      );
    }
    if (
      options.memberIdentityId !== null &&
      options.memberIdentityId !== undefined
    ) {
      filters.push(`MemberId eq ${options.memberIdentityId}`);
    }

    if (
      options.isPredetermined !== null &&
      options.isPredetermined !== undefined
    ) {
      filters.push(`IsPredetermined eq ${options.isPredetermined}`);
    }

    if (
      options.flags !== null &&
      options.flags !== undefined &&
      options.flags.length > 0
    ) {
      let flagsFilters = [];
      for (const flag of options.flags) {
        // console.log(flag);
        if (flag === "no-flags") {
          flagsFilters.push(`Flags/$count eq 0`);
        } else {
          flagsFilters.push(`Flags/any(__c_t: __c_t/Id eq ${flag})`);
        }
      }
      filters.push(`(${flagsFilters.join(" or ")})`);
    }

    if (options.cheque !== null && options.cheque !== undefined) {
      filters.push(
        `contains(tolower(PaymentNumber), '${options.cheque.toLowerCase()}')`
      );
    }

    // public virtual int? PaymentBatchNumber
    // {
    //     get => Payments.Any(p => p.CancelledAt == null) ? PaymentBatchNumberExpression.Evaluate(this) : null;
    //     set { }
    // }

    // protected static readonly CompiledExpression<ClaimSubmission, int?> PaymentBatchNumberExpression = DefaultTranslationOf<ClaimSubmission>
    //     .Property(e => e.PaymentBatchNumber)
    //     .Is(x => x.Payments.FirstOrDefault(p => p.CancelledAt == null).PaymentBatch.BatchNumber);

    // if (
    //   options.batchNumber !== null &&
    //   options.batchNumber !== undefined
    // ) {
    //   filters.push(
    //     `PaymentBatchNumber eq ${options.batchNumber}`
    //   );
    // }

    if (options.batchNumber !== null && options.batchNumber !== undefined) {
      filters.push(
        `Payments/any(__c_t: __c_t/CancelledAt eq null and __c_t/PaymentBatch/BatchNumber eq ${options.batchNumber})`
      );
    }

    if (options.payee !== null && options.payee !== undefined) {
      filters.push(`Payee eq '${options.payee}'`);
    }

    if (!options.selectPaymentAmountRange && options.paymentAmount) {
      // filters.push(`ClaimsTotal eq ${options.claimedAmount}`);
      //filters.push(`(TotalPaid eq ${options.paymentAmount} or Claims/any(__c_t: __c_t/TotalPaid eq ${options.claimedAmount}))`);
      filters.push(`PaymentAmount eq ${options.paymentAmount}`);
    }

    if (options.selectPaymentAmountRange && options.paymentAmountRange) {
      filters.push(
        // `ClaimsTotal ge ${options.claimedAmountRange[0]} and ClaimsTotal le ${
        //   options.claimedAmountRange[1]
        // }`
      //  `((TotalPaid ge ${options.paymentAmountRange[0].toFixed(2)} and TotalPaid le ${options.paymentAmountRange[1].toFixed(2)}) or (Claims/any(__c_t: __c_t/TotalPaid ge ${options.claimedAmountRange[0].toFixed(2)} and __c_t/TotalPaid le ${options.claimedAmountRange[1].toFixed(2)})))`
      `(PaymentAmount ge ${options.paymentAmountRange[0] .toFixed(2)} and PaymentAmount le ${options.paymentAmountRange[1] .toFixed(2)})`
      );
      
    }

    const filter = filters.length ? "&$filter=" + filters.join(" and ") : "";

    // const url = `${settings.APIURL}plans/${options.planIdentityId}/claim-submission/${options.memberIdentityId}`;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/claim-submission`;
    // const url = `https://dev.mapi.pbasconnect.com/plans/${options.planIdentityId}/claim-submission/${options.memberIdentityId}`;

    const expandQuery =
      "?$expand=Payments($expand=PaymentBatch),Flags($expand=Translations),Claims($expand=Proofs($expand=FileSegments),CurrentClaimData($expand=ToothCode,PlanBenefit($expand=Benefit($select=IsSickDay,Name,Code,Coverage))))";
    const pagination = `&$count=true&$skip=${
      options.itemsPerPage * (options.page - 1)
    }&$top=${options.itemsPerPage}`;
    const sort = options.sortBy
      ? `&$orderby=${options.sortBy} ${options.sortDesc ? "desc" : "asc"}`
      : "";

    // console.log(
    //   "searching submitted claims Filter",
    //   expandQuery + pagination + sort + filter
    // );
    const finalUrl = url + expandQuery + pagination + sort + filter;
    return ApiService.get(finalUrl);
    // return ApiService.getDeployedProxy(
    //   url + expandQuery + pagination + sort + filter
    // );
  },
  getPlanBenefitsRulesConfiguration({ state }, options) {
    const settings = SettingsService.settings;
    // const url = `${settings.APIURL}brokers/${
    //   options.brokerId
    // }/plan-benefits-guides`;
    const url = `${settings.APIURL}planbenefits/configuration`;

    return ApiService.post(url, options.payload);
  },
  getPlanBenefits({ state }, options) {
    //TODO: select and display also membrgroup in dropdown
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/plan-benefits/${options.languageCode}`;
    return ApiService.get(url);
  },
  async getBrokerPlansForClaims({ commit }, options) {
    try {
      var settings = SettingsService.settings;
      const url =
        settings.APIURL +
        "brokers/" +
        options.brokerId +
        "/draft-plans?$select=PlanIdentityId,Name,UniqueIdentifier,PlanType&$orderby=Name";
      let data = (await ApiService.get(url)).data.value.sort((a, b) =>
        sortAlphanum(a.Name, b.Name)
      );
      return {
        data: {
          value: data,
        },
      };
    } catch (error) {
      throw error;
    }
  },
  getRuleTypes({ state }) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}rule-type/configuration`;
    return ApiService.get(url);
  },
  importPlanBenefitsRules({ commit }, options) {
    // var guids = ["3f975b70-5e84-41a6-b836-8d63db481e0c", "eedfb70f-31d8-4f3e-afe1-0f3162d5cb1b"]
    const settings = SettingsService.settings;
    const url = settings.APIURL + "plan-benefits/rules/import";
    let formData = new FormData();
    for (let f of options.files) {
      formData.append("Files", f);
    }
    // formData.append("Files", options.files);
    formData.append("Payload", options.payload);
    return ApiService.postFile(url, formData);
  },
  getPlanBenefitCategories({ state }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    const dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url = `${settings.APIURL}member-groups/${options.memberGroupIdentityId}/effective-date/${dateFormatted}/plan-benefits/categories`;
    return ApiService.get(url);
  },
  getPlanBenefitsByEffectiveDateAndCategory({ state }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    const dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url = `${settings.APIURL}member-groups/${options.memberGroupIdentityId}/effective-date/${dateFormatted}/plan-benefits?$select=BenefitId&$expand=Benefit($select=Id,Name)&$filter=Benefit/Category eq '${options.category}'`;
    return ApiService.get(url);
  },
  getPlanBenefitByEffectiveDate({ state }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    const dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url = `${settings.APIURL}member-groups/${options.memberGroupIdentityId}/effective-date/${dateFormatted}/plan-benefits?$filter=BenefitId eq ${options.id}&&$select=PlanId,BenefitId,RequiresReferral,RequiresLetter,AdminOnly,MemberOnly&$expand=AuditRule,SupervisorAuditRule,BenefitRules`;
    return ApiService.get(url);
  },
  getPlanFeeGuides({ state }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    const dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/effective-date/${dateFormatted}/plan-fee-guides?$expand=FeeGuide($select=Name,Year,ProvinceId)`;
    return ApiService.get(url);
  },
  deletePlanBenefitRuleConfigurationByEffectiveDate({ state }, options) {
    const settings = SettingsService.settings;
    // const [date, time] = options.effectiveDate.split("T");
    // const [year, month, day] = date.split("-");
    // const dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/plan-benefits-rules/delete`;
    return ApiService.post(url, options.payload);
  },
  getPlanBenefitsDates({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/plan-benefits?$select=EffectiveDate`;
    return ApiService.get(url);
  },
  getSickDayBenefit({ state }, options) {
    const [date, time] = options.dateOfService.split("T");
    const [year, month, day] = date.split("-");
    const dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const settings = SettingsService.settings;
    const filter = "Benefit/IsSickDay eq true";
    const url = `${settings.APIURL}members/${options.memberIdentityId}/effective-date/${dateFormatted}/plan-benefits?$count=true&$skip=0&$top=50&$expand=Benefit($expand=TreatmentSite,Translations($select=Name,LanguageCode))&$filter=${filter}`;
    console.log(url);
    return ApiService.get(url);
  },
  getSickDaySubmissionSettings({ state }, options) {
    const [date, time] = options.dateOfService.split("T");
    const [year, month, day] = date.split("-");
    const dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/member-groups/${options.memberGroupIdentityId}/effective-date/${dateFormatted}/sick-day-submission-settings`;
    console.log(url);
    return ApiService.get(url);
  },
  getSickHourBankSettings({ state }, options) {
    const [date, time] = options.dateOfService.split("T");
    const [year, month, day] = date.split("-");
    const dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/member-groups/${options.memberGroupIdentityId}/effective-date/${dateFormatted}/sick-hour-bank-settings`;
    console.log(url);
    return ApiService.get(url);
  },
  getPlanBenefitsForClaimSubmission({ state }, options) {
    const [date, time] = options.dateOfService.split("T");
    const [year, month, day] = date.split("-");
    const dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const settings = SettingsService.settings;
    let filter = "";
    if (options.search) {
      filter = `((Benefit/Translations/any(__c_t: contains(tolower(__c_t/Name), '${options.search
        .toLowerCase()
        .replaceAll(
          "'",
          "''"
        )}'))) or contains(tolower(Benefit/Code), '${options.search
        .toLowerCase()
        .replaceAll("'", "''")}'))`;
    }
    // and Benefit/Coverage eq '${options.coverage}'
    if (options.coverage === "Health") {
      filter += `${
        filter ? " and " : ""
      }Benefit/Coverage eq 'Health' and Benefit/IsPrescriptionDrugs eq false`;
    } else if (options.coverage === "Prescription") {
      filter += `${
        filter ? " and " : ""
      }Benefit/Coverage eq 'Health' and Benefit/IsPrescriptionDrugs eq true`;
    } else if (options.coverage === "Dental") {
      filter += filter
        ? ` and Benefit/Coverage eq 'Dental'`
        : `Benefit/Coverage eq 'Dental'`;
    } else if (options.coverage === "SickDay") {
      filter = `${
        filter ? " and " : ""
      }Benefit/Coverage eq 'SickDay' or Benefit/IsSickDay eq true`;
    }
    if (options.filter) {
      filter += filter ? options.filter : options.filter.replace(" and", "");
    }
    const url =
      `${settings.APIURL}members/${options.memberIdentityId}/effective-date/${dateFormatted}/plan-benefits?$count=true&$skip=0&$top=50&$expand=Benefit($expand=TreatmentSite,Translations($select=Name,LanguageCode))` +
      (filter ? `&$filter=${filter}` : "");
    console.log(url);
    return ApiService.get(url);
  },
  getHsaCoveredBenefits({ state }, options) {
    const settings = SettingsService.settings;
    // let filter = `(LifestyleBenefit/Category eq '${options.category}' or Benefit/Category eq '${options.category}')`;
    let filter = `(LifestyleBenefit/Category eq '${options.category}' or Benefit/Category eq '${options.category}')`;
    if (options.search) {
      filter += ` and (((LifestyleBenefit/Translations/any(__c_t: contains(tolower(__c_t/Name), '${options.search
        .toLowerCase()
        .replaceAll(
          "'",
          "''"
        )}'))) or contains(tolower(LifestyleBenefit/Code), '${options.search
        .toLowerCase()
        .replaceAll("'", "''")}')) or 
        ((Benefit/Translations/any(__c_t: contains(tolower(__c_t/Name), '${options.search
          .toLowerCase()
          .replaceAll(
            "'",
            "''"
          )}'))) or contains(tolower(Benefit/Code), '${options.search
        .toLowerCase()
        .replaceAll("'", "''")}')))`;
    }
    // and Benefit/Coverage eq '${options.coverage}'
    // if (options.coverage === "Health") {
    //   filter += ` and Benefit/Coverage eq 'Health' and Benefit/IsPrescriptionDrugs eq false`;
    // } else if (options.coverage === "Prescription") {
    //   filter += ` and Benefit/Coverage eq 'Health' and Benefit/IsPrescriptionDrugs eq true`;
    // } else if (options.coverage === "Dental") {
    //   filter += ` and Benefit/Coverage eq 'Dental'`;
    // } else if (options.coverage === "SickDay") {
    //   filter =
    //     " and Benefit/Coverage eq 'SickDay' or Benefit/IsSickDay eq true";
    // }
    // if (options.filter) {
    //   filter += options.filter;
    // }
    const url = `${settings.APIURL}plans/covered-benefits/${options.coveredBenefitId}?$count=true&$skip=0&$top=250&$expand=Benefit($expand=TreatmentSite,Translations($select=Name,LanguageCode)),LifestyleBenefit($expand=Translations($select=Name,LanguageCode))&$filter=${filter}`;
    console.log("getHsaCoveredBenefits url:", url);
    return ApiService.get(url);
  },
  // async getHsaBenefitCategories({ state }, options) {
  //   const settings = SettingsService.settings;
  //   const url = `${settings.APIURL}plans/covered-benefits/${options.coveredBenefitId}?$expand=Benefit($select=Category,Coverage),LifestyleBenefit($select=Category,Coverage)&$select=Id,IsLifestyle`;
  //   console.log("getHsaCoveredBenefits url:", url);
  //   let data = (await ApiService.get(url)).data;
  //   console.log(data);
  //   const uniqueSortedCategories = [
  //     ...new Set(
  //       data.value
  //         .filter((item) =>
  //           item.IsLifestyle
  //             ? item.LifestyleBenefit?.Coverage !== "Dental"
  //             : item.Benefit?.Coverage !== "Dental"
  //         )
  //         .map((item) =>
  //           item.IsLifestyle
  //             ? item.LifestyleBenefit?.Category
  //             : item.Benefit?.Category
  //         )
  //         .filter(Boolean)
  //     ),
  //   ].sort();
  //   if (
  //     data.value.filter((item) =>
  //       item.IsLifestyle
  //         ? item.LifestyleBenefit?.Coverage === "Dental"
  //         : item.Benefit?.Coverage === "Dental"
  //     ).length > 0
  //   ) {
  //     uniqueSortedCategories.push("Dental");
  //   }
  //   console.log("uniqueSortedCategories", uniqueSortedCategories);
  //   return uniqueSortedCategories.sort();
  // },
  getHsaBenefitCategories({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/covered-benefits/${options.coveredBenefitId}?$expand=Benefit($select=Category,Coverage),LifestyleBenefit($select=Category,Coverage)&$select=Id,IsLifestyle`;
    console.log("getHsaCoveredBenefits url:", url);
    return ApiService.get(url);
  },

  newClaimSubmission({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "claim-submissions";
    return ApiService.post(url, options.payload);
  },
  updateClaimSubmission({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "claim-submissions/" + options.id;
    return ApiService.put(url, options.payload);
  },
  submitClaimSubmission({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}claim-submissions/${options.id}/submit`;
    return ApiService.get(url);
  },
  getProvidersForClaimSubmission({ state }, options) {
    const settings = SettingsService.settings;
    let filters = [
      `(contains(tolower(FirstName), '${options.search
        .toLowerCase()
        .replaceAll(
          "'",
          "''"
        )}') or contains(tolower(LastName), '${options.search
        .toLowerCase()
        .replaceAll(
          "'",
          "''"
        )}') or contains(tolower(UniqueId), '${options.search
        .toLowerCase()
        .replaceAll("'", "''")}'))`,
    ];
    if (options.coverageType !== null && options.coverageType !== undefined) {
      filters.push(`ProviderType eq '${options.coverageType}'`);
    }
    const filter = filters.join(" and ");
    const url = `${settings.APIURL}providers?$count=true&$skip=0&$top=20&$filter=${filter}&$expand=ProviderOffices($expand=Office($expand=Province))`;
    return ApiService.get(url);
  },
  newProvider({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "providers";
    return ApiService.post(url, options.payload);
  },
  getClaimSubmissionById({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "claim-submissions/" + options.id;
    return ApiService.get(url);
  },
  getPaymentsByClaimSubmissionId({ commit }, options) {
    const settings = SettingsService.settings;
    const url = settings.APIURL + "claim-submissions/payments/" + options.id;
    return ApiService.get(url);
  },
  getPlanBenefitById({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plan-benefits/${options.id}?$expand=Benefit($expand=TreatmentSite,Translations($select=Name,LanguageCode))`;
    return ApiService.get(url);
  },
  getProviderById({ state }, options) {
    const settings = SettingsService.settings;
    const filter = `Id eq ${options.id}`;
    const url = `${settings.APIURL}providers?$count=true&$skip=0&$top=20&$filter=${filter}&$expand=ProviderOffices($expand=Office($expand=Province))`;
    return ApiService.get(url);
  },
  deleteClaimById({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}claims/${options.claimId}/delete`;
    return ApiService.post(url);
  },
  adjudicateClaimById({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}claims/${options.claimId}/adjudicate`;
    return ApiService.post(url);
  },
  deactivateDrug({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}drugs/${options.id}/deactivate/${options.effectiveDate}`;
    return ApiService.get(url);
  },
  deleteDrugs({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}drugs/delete`;
    return ApiService.post(url, options.payload);
  },
  async saveDrug({ commit }, item) {
    var settings = SettingsService.settings;
    if (!item.Id) {
      const url = `${settings.APIURL}drugs`;
      return (await ApiService.post(url, item)).data;
    } else {
      const url = `${settings.APIURL}drugs/${item.Id}`;
      return (await ApiService.put(url, item)).data;
    }
  },
  async importDrugs({ commit }, { base64, name, planId }) {
    const file = actions.dataURLtoFile(base64, name);
    const data = new FormData();
    data.append("file", file, file.name);
    // data.append("planId", planId);
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}drugs/import/${planId}`;
    return (await ApiService.postFile(url, data)).data;
  },
  dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n) {
      u8arr[n - 1] = bstr.charCodeAt(n - 1);
      n -= 1; // to make eslint happy
    }
    return new File([u8arr], filename, { type: mime });
  },
  getPlanDrugsForClaimSubmission({ state }, options) {
    const settings = SettingsService.settings;
    let filter = `contains(tolower(DIN), '${options.search
      .toLowerCase()
      .replaceAll("'", "''")}')`;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/drugs-formulary?$count=true&$skip=0&$top=20&$filter=${filter}`;
    return ApiService.get(url);
  },
  getProviderOffice({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}provider-offices/${options.providerId}/${options.officeId}?$expand=Office`;
    return ApiService.get(url);
  },
  deleteProvider({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}providers/${options.providerId}`;
    return ApiService.delete(url);
  },
  updateBillingInfo({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}providers/${options.providerId}/${options.officeId}/update-billing-info`;
    return ApiService.put(url, options.payload);
  },
  updateProvider({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}providers/${options.providerId}`;
    return ApiService.put(url, options.payload);
  },
  getPendingPaymentClaimSubmissions({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/claim-submission`;

    let filters = [];
    // const filter = `&$filter=PaymentMethod eq '${options.paymentMethod} and '`
    filters.push(`PaymentMethod eq '${options.paymentMethod}'`);
    filters.push(`Claims/any(__c_t: __c_t/State eq 'Approved')`);
    filters.push(
      `not ((Claims/any(__c_t: __c_t/State eq 'New') or Claims/any(__c_t: __c_t/State eq 'Pended')))`
    );

    const filter = filters.length ? "&$filter=" + filters.join(" and ") : "";

    const expandQuery =
      "?$expand=Claims($expand=Proofs($expand=FileSegments),ClaimDataHistory,CurrentClaimData($expand=PlanBenefit($expand=Benefit($select=Name,Code))))";
    const pagination = `&$count=true&$skip=${
      options.itemsPerPage * (options.page - 1)
    }&$top=${options.itemsPerPage}`;
    const sort = options.sortBy
      ? `&$orderby=${options.sortBy} ${options.sortDesc ? "desc" : "asc"}`
      : "";

    // console.log(
    //   "searching submitted claims Filter",
    //   expandQuery + pagination + sort + filter
    // );
    return ApiService.get(
      url + expandQuery + pagination + sort + filter,
      1000 * 60 * 10
    );
    // return ApiService.getDeployedProxy(
    //   url + expandQuery + pagination + sort + filter
    // );
  },
  newBatch({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}claim-payments/batch-payment`;
    return ApiService.post(url, options.payload);
  },
  exportBatchFile({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/claim-payments/${options.batchId}/export-dd-batch-file`;
    return ApiService.get(url);
  },
  rejectClaimById({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}claims/${options.claimId}/reject`;
    return ApiService.post(url, options.payload);
  },
  getDrugByDIN({ state }, options) {
    const settings = SettingsService.settings;
    const filter = `DIN eq '${options.din}'`;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/drugs-formulary?$count=true&$skip=0&$top=20&$filter=${filter}`;
    return ApiService.get(url);
  },
  getProofById({ state }, options) {
    const settings = SettingsService.settings;
    // const filter = `DIN eq '${options.din}'`;
    const url = `${settings.APIURL}proofs/${options.proofId}`;
    return ApiService.get(url);
  },
  pendClaimById({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}claims/${options.claimId}/pend`;
    return ApiService.post(url, options.payload);
  },
  getMemberHsa({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/members/${options.memberIdentityId}/hsa?$select=CurrentBalance&$expand=Plan,Credits,HSACreditToExpire`;
    return ApiService.get(url);
  },
  addMemberCredit({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/credits";
    return ApiService.post(url, options.payload);
  },
  updateMemberCredit({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/credits/" +
      options.creditId;
    return ApiService.put(url, options.payload);
  },
  deleteMemberCredit({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.planIdentityId +
      "/members/" +
      options.memberIdentityId +
      "/delete-credits/" +
      options.creditId;
    return ApiService.put(url, options.payload);
  },
  getPlanCoveredBenefits({ state }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.effectiveDate.split("T");
    const [year, month, day] = date.split("-");
    const dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/effective-date/${dateFormatted}/covered-benefits?$expand=Benefit($expand=TreatmentSite,Translations($select=LanguageCode,Name))`;
    return ApiService.get(url);
  },
  getMemberGroupIdentityId({ state }, options) {
    const settings = SettingsService.settings;
    const [date, time] = options.date.split("T");
    const [year, month, day] = date.split("-");
    const dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
    const url = `${settings.APIURL}members/${options.memberIdentityId}/date/${dateFormatted}/member-group-identity-id`;
    return ApiService.get(url);
  },
  getCoveredBenefitById({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/covered-benefits/${options.id}?$expand=Benefit($expand=TreatmentSite,Translations($select=LanguageCode,Name)),LifestyleBenefit($expand=Translations($select=LanguageCode,Name))`;
    return ApiService.get(url);
  },
  postConfirmMatchHsa({ commit }, options) {
    const settings = SettingsService.settings;
    const url =
      settings.APIURL +
      "plans/" +
      options.plan +
      "/hsa-import/parse/" +
      options.guid;
    return ApiService.post(url, options.payload);
  },
  importHsa({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans/${options.planIdentityId}/hsa-import`;
    let formData = new FormData();
    formData.append("File", options.file);
    return ApiService.postFile(url, formData);
  },
  exportPayments({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}claim-payments/export`;
    return ApiService.post(url, options.payload);
  },
  cancelPayment({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}claim-payments/cancel-payment`;
    return ApiService.post(url, options.payload);
  },
  getPlansWithoutClaimSettings({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}claim-plan-settings/${options.brokerId}/plans?$select=Number,PlanId`;
    return ApiService.get(url);
  },
  addClaimSettings({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}claim-plan-settings`;
    return ApiService.post(url, options.payload);
  },
  updateClaimSettings({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}claim-plan-settings/${options.id}`;
    return ApiService.put(url, options.payload);
  },
  flagClaims({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}flag-claims`;
    return ApiService.post(url, options.payload);
  },
  getMemberBenefitBalances({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}benefit-balance/fetch`;
    return ApiService.post(url, options.payload);
  },
  getClaimSettings({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}claim-plan-settings/${options.brokerId}?$expand=ClaimAdmin($select=Name,Address,Phone,TollFreePhone,LogoBase64;$expand=Translations($select=Name,Address,Phone,TollFreePhone,LanguageCode,LogoBase64)),Underwriter($select=Name,LogoBase64;$expand=Translations($select=Name,LogoBase64,LanguageCode))&$select=EOBPlanAddress,EOBPlanPhone,EOBPlanEmail&$filter=PlanId eq ${options.planIdentityId}`;
    return ApiService.get(url);
  },
  addClaimAdmin({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}claim-admins`;
    return ApiService.post(url, options.payload);
  },
  updateClaimAdmin({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}claim-admins/${options.id}`;
    return ApiService.put(url, options.payload);
  },
  addUnderwriter({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}underwriters`;
    return ApiService.post(url, options.payload);
  },
  updateUnderwriter({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}underwriters/${options.id}`;
    return ApiService.put(url, options.payload);
  },
  getClaimAdmins({ commit }) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}claim-admins?$select=Id,Name&$expand=Translations($select=Name,LanguageCode)`;
    return ApiService.get(url);
  },
  getUnderwriters({ commit }) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}underwriters?$select=Id,Name&$expand=Translations($select=Name,LanguageCode)`;
    return ApiService.get(url);
  },
  getFees({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}fees?$expand=FeeGuide($select=ProvinceId),Benefit($select=Name,Category)&$select=Id,Code,IndividualFee,Fee,IndividualLabFee,LabFee&$filter=${options.filter}`;
    return ApiService.get(url);
  },
  getPlansWithoutFeeGuides({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plans-depending-fee-guide/${options.brokerId}/false/coverage/${options.coverage}?$expand=ClaimSettings($select=FeeGuideProvince)&$select=PlanId,Number`;
    return ApiService.get(url);
  },
  addPlanFeeGuide({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plan-fee-guides`;
    return ApiService.post(url, options.payload);
  },
  updatePlanFeeGuideProvince({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}fee-guide-province`;
    return ApiService.put(url, options.payload);
  },
  deletePlanFeeGuide({ commit }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.APIURL}plan-fee-guides/${options.id}`;
    return ApiService.delete(url);
  },
  searchProvidersForClaimSubmission({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const search = options.search.toLowerCase().replaceAll("'", "''");

    const filters = [];

    if (options.coverageTypes.length > 0) {
      const providerTypeFilter = options.coverageTypes
        .map((o) => `ProviderType eq '${o}'`)
        .join(" or ");
      filters.push(`(${providerTypeFilter})`);
    } else if (options.submissionType === "DentalProvider") {
      const submissionTypeDentalFilter = `ProviderType eq 'Dental'`;
      filters.push(`(${submissionTypeDentalFilter})`);
    } else if (options.submissionType === "HealthProvider") {
      const submissionTypeDentalFilter = `ProviderType eq 'Health'`;
      filters.push(`(${submissionTypeDentalFilter})`);
    }

    console.log(filters);
    const searchFilter = `contains(tolower(FirstName), '${search}') or contains(tolower(LastName), '${search}') or contains(tolower(UniqueId), '${search}')`;
    filters.push(`(${searchFilter})`);

    const filter = filters.join(" and ");

    const url = `${
      settings.APIURL
    }providers?$count=true&$skip=${options.skip}&$top=${
      options.top
    }&$filter=${encodeURIComponent(
      filter
    )}&$expand=ProviderOffices($expand=Office($expand=Province))&$orderby=UniqueId`;

    console.log(url);
    return ApiService.get(url);
  },
  searchPlanBenefits({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const search = options.search.toLowerCase().replaceAll("'", "''");
    const language = options.language.toLowerCase().replaceAll("'", "''");
    const filters = [];
    // if (options.memberGroupIdentityIds.length > 0) {
    //   const memberGroupFilter = `MemberGroupIds/any(id: id in (${options.memberGroupIdentityIds.join(
    //     ", "
    //   )}))`;
    //   filters.push(`(${memberGroupFilter})`);
    // }
    const searchFilter = `contains(tolower(Name), '${search}') and tolower(LanguageCode) eq '${language}'`;
    filters.push(`(${searchFilter})`);
    const filter = filters.join(" and ");
    const url = `${settings.APIURL}benefits/${
      options.planIdentityId
    }?$count=true&$skip=${options.skip}&$top=${
      options.top
    }&$filter=${encodeURIComponent(filter)}`;
    const payload = {
      PlanId: options.planIdentityId,
      MemberGroupIds: options.memberGroupIdentityIds
    }
    return ApiService.post(url, payload);
  },
};

const mutations = {};

export const claims = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
